module.exports = __webpack_public_path__ + "down_small.png?0e5e83095dba76b2994c1f851dd7ce62";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down_small.png
// module id = 960
// module chunks = 2